import React, { useState, useEffect } from "react";
import axios from "../../library/axios";
import { Base64ViewerComp, DatatableDocumentSupports } from "../../components";
import { formatDate } from "../../helpers/formatDate";
import { MySwal } from "../../library/swal";
import { useLocation } from "react-router-dom";
import { LoadingAtom } from "../../components/";
import { IconSearch } from "@tabler/icons-react";
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { downloadDocumentWithAlert } from "../../helpers/downloadDocument";
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const DocumentSurveiPage = () => {
  const baseUrl = new URL(window.location.href);
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState("");
  const [listKegiatanSurvei, setListKegiatanSurvei] = useState([]);
  const [disabledChapter, setdisabledChapter] = useState(true);
  const [chapters, setchapters] = useState([]);
  const [chapterId, setchapterId] = useState("");
  const [filterDocuments, setFilterDocuments] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [idKegiatanAkreditasi, setIdKegiatanAkreditasi] = useState("");
  const [disabled, setdisabled] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [link, setLink] = useState("");
  // Info dokumen (nama + deskripsi) untuk ditampilkan di modal viewer.
  const [docInfo, setDocInfo] = useState({
    namaFile: "",
    deskripsi: "",
    downloadPath: "",
  });
  const [isPdf, setisPdf] = useState("application/pdf");
  const [lgShowIframe, setLgShowIframe] = useState(false);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const fetchListSurvei = async () => {
    try {
      const options = {
        url: `/accreditations/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      setListKegiatanSurvei(data);
    } catch (err) {
      notifyApiLoadError(err, 'pages/document-survei/index.fetchListSurvei');
    }
  };

  const fetchChapters = async (param) => {
    try {
      const options = {
        url: `/chapters/getListByFk/${param}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      setchapters(data);
      setdisabledChapter(false);
    } catch (err) {
      notifyApiLoadError(err, 'pages/document-survei/index.fetchChapters');
      setdisabledChapter(true);
    }
  };

  const fetchAccreditation = async (param) => {
    // console.log(param);
    // return false;
    try {
      const options = {
        url: `/accreditations/detailAccreditationParam/${param}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      fetchChapters(data?.IdMasterAkreditasi);
    } catch (err) {
      notifyApiLoadError(err, 'pages/document-survei/index.fetchAccreditation');
      setdisabledChapter(true);
    }
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: "info",
          title: "Oops, Unauthorize!",
          text: "Session anda habis, Silahkan login kembali.",
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: "info",
            title: "Oops, No Access!",
            text: "Anda tidak memiliki akses di halaman ini.",
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/document-survei/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchListSurvei();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilter = async () => {
    if (idKegiatanAkreditasi === "") {
      MySwal.fire({
        icon: "info",
        title: "Oops, Error!",
        text: "Periode Survei tidak boleh kosong!",
      });
      return false;
    }

    if (chapterId === "") {
      MySwal.fire({
        icon: "info",
        title: "Oops, Error!",
        text: "Bab tidak boleh kosong!",
      });
      return false;
    }
    setLoadingData(true);
    setdisabled(true);
    try {
      const options = {
        url: `/document-supports/${idKegiatanAkreditasi}/${chapterId}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      setLoadingData(false);
      setdisabled(false);
      if (data.length === 0) {
        MySwal.fire({
          icon: "info",
          title: "Request Pending",
          text: "Anda belum mengupload dokumen pendukung!",
        });
        return false;
      }
      setDocuments(data);
      setFilterDocuments(data);
      // fetchBab(param)
      // fetchtEp(param)
    } catch (err) {
      notifyApiLoadError(err, 'pages/document-survei/index.handleFilter');
      setLoadingData(false);
      setdisabled(false);
    }
  };

  const handleChangeKegiatan = (value) => {
    setIdKegiatanAkreditasi(value);
    fetchAccreditation(value);
  };

  useEffect(() => {
    // hilangkan spasi/titik & lowercase, agar "HPK 1.4" cocok dengan "HPK. 1.4"
    const normalize = (text) =>
      (text ?? "").toString().toLowerCase().replace(/[^a-z0-9]/g, "");
    const keyword = normalize(search);

    const result = documents.filter((item) => {
      const nomor =
        item.skor?.variables_accreditation?.elements_accreditation?.Nomor?.toString() ?? "";
      const abjad = item.skor?.variables_accreditation?.Abjad ?? "";
      const deskripsiElemen = item.skor?.variables_accreditation?.Deskripsi ?? "";
      const elemenPenilaian = `${abjad}. ${deskripsiElemen}`;
      const namaFile = item.namaFile ?? "";

      return normalize(`${nomor} ${elemenPenilaian} ${namaFile}`).includes(keyword);
    });

    const sorted = [...result].sort((a, b) => {
      // Nomor berupa teks (mis. "MFK 8.2.1") jadi tidak bisa dibandingkan sebagai angka,
      // gunakan Urutan (integer berurutan) sebagai kunci sort utama.
      const urutanA = Number(a.skor?.variables_accreditation?.elements_accreditation?.Urutan);
      const urutanB = Number(b.skor?.variables_accreditation?.elements_accreditation?.Urutan);

      if (!Number.isNaN(urutanA) && !Number.isNaN(urutanB) && urutanA !== urutanB) {
        return urutanA - urutanB;
      }

      const abjadA = a.skor?.variables_accreditation?.Abjad ?? "";
      const abjadB = b.skor?.variables_accreditation?.Abjad ?? "";

      return abjadA.localeCompare(abjadB, undefined, { numeric: true, sensitivity: "base" });
    });

    setFilterDocuments(sorted);
  }, [search, documents]);



  const handleShowDocument = async (id) => {
    try {
      setLink("");
      setDocInfo({ namaFile: "", deskripsi: "", downloadPath: "" });
      const options = {
        url: `/skor/show-dokumen/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data.data.mimeType !== isPdf) {
        // Berkas non-PDF tidak bisa dirender viewer, jadi langsung diunduh --
        // lewat endpoint ber-auth, bukan URL statis, supaya group yang dilarang
        // mengunduh tetap tertahan di server.
        await downloadDocumentWithAlert(
          `/skor/download-dokumen/${id}`,
          data.data.namaFile
        );
        return false;
      }
      setDocInfo({
        namaFile: data?.data?.namaFile || "",
        deskripsi: data?.data?.Deskripsi || "",
        downloadPath: `/skor/download-dokumen/${id}`,
      });
      const concatUrl = baseUrl.origin.concat(`/${data.data.link}`);
      setLgShowIframe(true);
      setLink(concatUrl);
    } catch (err) {
      setLgShowIframe(false);
      notifyApiLoadError(err, 'pages/document-survei/index.handleShowDocument');
    }
  };

  // console.log(filterDocuments)

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Dokumen Survei Page
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-5">
                      <div className="col-lg-4 col-12">
                        <select
                          className="form-select"
                          aria-label="Select example"
                          onChange={(e) => handleChangeKegiatan(e.target.value)}
                          value={idKegiatanAkreditasi}
                        >
                          <option value="">- Pilih Periode Survei -</option>
                          {listKegiatanSurvei.map((survei) => (
                            <option key={survei.id} value={survei.id}>
                              {formatDate(survei.TglMulai)} s/d{" "}
                              {formatDate(survei.TglBerakhir)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-4 col-12">
                        <select
                          className="form-select"
                          aria-label="Select example"
                          onChange={(e) => setchapterId(e.target.value)}
                          value={chapterId}
                          disabled={disabledChapter}
                        >
                          <option value="">- Pilih Bab -</option>
                          {chapters.map((chapter) => (
                            <option key={chapter.id} value={chapter.id}>
                              {chapter.Deskripsi} ({chapter.Singkatan})
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-4 col-12">
                        <button
                          onClick={handleFilter}
                          className="btn btn-sm btn-success"
                          disabled={disabled}
                        >
                          <IconSearch stroke={2} />{" "}
                          {disabled === true ? "Loading..." : "Cari"}
                        </button>
                      </div>
                    </div>
                    {loadingData === true ? (
                      <LoadingAtom />
                    ) : (
                      <>
                        <div className="row">
                          {documents.length > 0 ? (
                            <>
                              <DatatableDocumentSupports
                                documents={filterDocuments}
                                search={search}
                                handleChangeSearch={handleChangeSearch}
                                showDocument={handleShowDocument}
                              />

                              {lgShowIframe === true ? (
                                <Base64ViewerComp
                                  link={link}
                                  namaFile={docInfo.namaFile}
                                  deskripsi={docInfo.deskripsi}
                                  downloadPath={docInfo.downloadPath}
                                  close={() => setLgShowIframe(false)}
                                />
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}
    </>
  );
};

export default DocumentSurveiPage;
